import moment from 'moment'

export default (date, withoutSuffix = false) => {
  const momentDate = moment(date)
  momentDate.locale(import.meta.env.VITE_COUNTRY)

  return momentDate.fromNow(withoutSuffix)
}
